import { AgentState } from "@beydesign/storybook"

export enum ApiVersion {
  v1 = "v1",
  v2 = "v2",
}

export enum Endpoints {
  avatar = "avatars",
  video = "videos",
  creator = "creators",
  billing = "billing",
  dataset = "datasets",
  agent = "agents",
  knowledge = "knowledge-files",
  ask_ai_calls = "ask-ai/calls",
  calls = "calls",
  feedback = "feedbacks",
  developer_key = "developer-keys",
  webhook = "webhook",
  analytics = "analytics",
  external_api = "external-apis",
}

export enum SecondPathParam {
  stripe_session = "stripe-session",
  stripe_portal_url = "stripe-portal-url",
  usage = "usage",
  generate = "generate",
  load = "load",
  load_preview = "load_preview",
  generate_videos = "generate_videos",
  generate_text = "generate_text",
  download_sample = "download-sample",
  load_preview_image = "load_preview_image",
  upload = "upload",
  process = "process",
  download_all_videos = "download_all_videos",
  generate_csv = "generate_csv",
  calls = "calls",
  messages = "messages",
  products = "products",
  checkout_sessions = "checkout-sessions",
  pay_as_you_go = "pay-as-you-go",
  overview = "overview",
  insights = "insights",
  next_steps = "next-steps",
  webhook = "webhook",
  daily_usage = "daily-usage",
}

export enum Method {
  POST = "POST",
  PATCH = "PATCH",
  GET = "GET",
  PUT = "PUT",
  DELETE = "DELETE",
}

export enum ReturnTypes {
  json = "json",
  blob = "blob",
}

export enum ApiState {
  pending = AgentState.pending,
  processing = AgentState.processing,
  error = AgentState.error,
  ready = AgentState.ready,
}

export type QueryParams = {
  cursor: string
  limit: number
}

export interface CustomerCheckoutModel {
  price_id: string
  return_url: string
  after_completion_url: string
  promo_code: string | null
}

export interface CustomerCheckoutResponse {
  checkout_url: string
  session_id: string
}

export interface PayAsYouGoModel {
  enabled: boolean
  return_url: string
}

export interface PayAsYouGoResponse {
  requires_setup: boolean
  setup_url?: string
  session_id?: string
  pay_as_you_go_enabled?: boolean
}
